<template>
  <div class="download" :class="{'download-pc':!isMobile,'download-m':isMobile}">
    <div class="title-box">
      <img src="../assets/images/img/light.png" height="61" width="28" alt />
      <div>
        <div class="left-line"></div>
        <span class="wallet-title">比特元钱包下载</span>
        <div class="right-line"></div>
      </div>
      <p class="version orange">
        版本号：{{walletVersion}}
        <span>更新时间：{{updateTime}}</span>
      </p>
    </div>
    <div class="download-box" v-for="(item,index) in downList" :key="index">
      <div class="BoxWrap">
        <div class="horn">
          <div class="lt" v-show="item.show===true"></div>
          <div class="rt" v-show="item.show===true"></div>
          <div class="rb" v-show="item.show===true"></div>
          <div class="lb" v-show="item.show===true"></div>
          <a
            class="inner"
            target="_blank"
            @mouseover="item.show=true"
            @mouseout="item.show=false"
            :href="item.downUrl"
          >
            <div class="inner-content">
              <img :src="item.url" height="60" width="60" alt />
              <p class="orange">{{item.word}}</p>
              <p>立即下载</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getwalletVersion } from "@/assets/js/api.js";
export default {
  data() {
    return {
      isMobile: false,
      walletVersion: "v6.1.0",
      updateTime: "2019-02-01",
      downList: [
        {
          url: require("../assets/images/img/mac2x.png"),
          downUrl: "https://bityuan.com/wallet?",
          word: "MAC",
          show: false
        },
        {
          url: require("../assets/images/img/windows2x.png"),
          downUrl: "https://bityuan.com/wallet?1",
          word: "Windows",
          show: false
        },
        {
          url: require("../assets/images/img/linux2x.png"),
          downUrl: "https://bityuan.com/wallet?1",
          word: "Linux",
          show: false
        }
      ]
    };
  },
  mounted() {
    this.isMobile = this.$store.state.isMobile;
    this.WalletVersion();
  },
  methods: {
    //获取钱包版本
    WalletVersion() {
      getwalletVersion().then(data => {
        if (data.code === 0) {
          this.updateTime = data.data[0].updated_at.substring(0, 10);
          this.walletVersion = data.data[0].version;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// pc
.download-pc {
  min-width: 1300px;
  text-align: center;
  height: 600px;
  padding: 50px 10%;
  margin: 0 auto;
  .download-box {
    margin-top: 100px;
    width: 20%;
    display: inline-block;
  }
  .wallet-title {
    margin: 23px 17px 26px;
    font-size: 30px;
  }
  .BoxWrap {
    width: 200px;
    height: 230px;
  }
  .left-line,
  .right-line {
    margin-top: 10px;
    padding-top: 10px;
  }
  .inner {
    width: 200px;
    height: 230px;
    .inner-content {
      padding-top: 45px;
      p:nth-of-type(1) {
        margin-top: 38px;
        font-size: 20px;
      }
      p:nth-of-type(2) {
        margin-top: 23px;
        font-size: 14px;
      }
    }
  }
  .horn {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .horn > div {
    width: 35px;
    height: 35px;
    position: absolute;
  }
  .horn .lt {
    border-top: 2px solid #fac865;
    border-left: 2px solid #fac865;
    left: -2px;
    top: -2px;
  }
  .horn .rt {
    border-top: 2px solid #fac865;
    border-right: 2px solid #fac865;
    right: -2px;
    top: -2px;
  }
  .horn .rb {
    border-bottom: 2px solid #fac865;
    border-right: 2px solid #fac865;
    right: -2px;
    bottom: -2px;
  }
  .horn .lb {
    border-bottom: 2px solid #fac865;
    border-left: 2px solid #fac865;
    left: -2px;
    bottom: -2px;
  }
  .inner:hover {
    cursor: pointer;
    color: #fac865 !important;
  }
}

// 适配移动
.download-m {
  margin: 0 auto;
  height: 140vw;
  text-align: center;
  .download-box {
    float: left;
  }
  .wallet-title {
    margin: 3vw;
    font-size: 18px;
  }
  .BoxWrap {
    width: 50vw;
    height: 50vw;
  }
  .left-line,
  .right-line {
    margin-top: 1vw;
    padding-top: 1vw;
  }
  .inner {
    width: 50vw;
    height: 50vw;
    .inner-content {
      padding-top: 12vw;
      img {
        width: 8vw;
        height: 8vw;
      }
      p:nth-of-type(1) {
        margin-top: 7vw;
        font-size: 16px;
      }
      p:nth-of-type(2) {
        margin-top: 4vw;
        font-size: 14px;
      }
    }
  }
}
</style>

<style lang="scss">
.download {
  background: $black_bg;
  .title-box {
    text-align: center;
    .left-line,
    .right-line {
      display: inline-block;
      height: 1px;
      width: 35px;
      border-top: 1px solid #5c5c5c;
    }
    .wallet-title {
      color: $black_font_white;
    }
    .version {
      margin-top: 16px;
      font-size: 14px;
    }
  }
  .BoxWrap {
    position: relative;
    display: inline-block;
  }
  .inner {
    color: #fff;
    .inner-content {
      text-align: center;
    }
  }
  .orange {
    color: $black_font_light;
  }
}
</style>